var _rect, _rect2, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 17,
    transform: "translate(0 0.5)",
    fill: "#008080"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    transform: "translate(7 3)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 7,
    r: 1.5,
    fill: "#008080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.5C10.567 9.5 9 10.8431 9 12.5H16C16 10.8431 14.433 9.5 12.5 9.5Z",
    fill: "#008080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceid);
export default __webpack_public_path__ + "static/media/faceid.361dd44afc8724eb5d06f8693cb293d0.svg";
export { ForwardRef as ReactComponent };